import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { LoyaltyCardDetail, LoyaltyManualDiscountUpdate } from '@crm/shared';
import { api } from '../../lib/api';

export const loyaltyKeys = {
  all: ['loyalty'] as const,
  card: (clientId: number) => ['loyalty', 'card', clientId] as const,
};

export function useLoyaltyCard(clientId: number | null, enabled = true) {
  return useQuery({
    queryKey: clientId ? loyaltyKeys.card(clientId) : ['loyalty', 'card', 'noop'],
    enabled: clientId !== null && enabled,
    queryFn: async () => {
      const res = await api.get<LoyaltyCardDetail>(`/loyalty/cards/${clientId}`);
      return res.data;
    },
  });
}

export function useSetManualDiscount(clientId: number) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (input: LoyaltyManualDiscountUpdate) => {
      const res = await api.patch<LoyaltyCardDetail>(
        `/loyalty/cards/${clientId}/manual-discount`,
        input,
      );
      return res.data;
    },
    onSuccess: (data) => {
      qc.setQueryData(loyaltyKeys.card(clientId), data);
    },
  });
}
